// extracted by mini-css-extract-plugin
export default {"container":"Footer_styles_container__ym5T9","madeBy":"Footer_styles_madeBy__YFiT3"};